/**
 * Generated runtime TestId mirror for frontend/src/pages/provisioning/ProvisioningDashboard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const ProvisioningDashboardTestIds = {
  btnArchiveCompleted: "btn-archive-completed",
  btnProcessAll: "btn-process-all",
  btnRequeueReady: "btn-requeue-ready",
  cardTitleAboutProvisioningTasks: "card-title-about-provisioning-tasks",
  cardTitleStat: "card-title-stat",
  provisioningDashboardPage: "provisioning-dashboard-page",
  statCompleted: "stat-completed",
  statFailed: "stat-failed",
  statQueued: "stat-queued",
  statRunning: "stat-running",
  value: (root: string) => `${root}-value`
} as const;
